module.exports = __webpack_public_path__ + "static/img/nalongo.173079e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/beads/nalongo.jpg
// module id = 90
// module chunks = 1